import sumBy from 'lodash.sumby';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { VirtualizedTableColumnKey } from 'services/virtualizedTable/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { OwnProps } from '.';
import { selectSearchedItemArray } from '../../selectors';

const selectColumnKey = (
    _state: AppState,
    props: OwnProps
): VirtualizedTableColumnKey | undefined => props.columnKey;

const selectFooterSummaryValue = createDeepEqualSelector(
    [selectSearchedItemArray, selectColumnKey],
    (searchedItemArray, columnKey) => {
        if (columnKey) {
            return sumBy(searchedItemArray, (item: any) => {
                const itemValue = get(item, columnKey);

                // Use 0 when value is falsy to prevent concatenation
                return itemValue || 0;
            });
        }

        return undefined;
    }
);

const makeSelectFooterSummaryValue = (): typeof selectFooterSummaryValue =>
    selectFooterSummaryValue;

export { selectFooterSummaryValue, makeSelectFooterSummaryValue };
